import { OverviewStatus, ReportStatus } from '@/types/detailAll';

/*-----------------common-------------------*/

interface StatusStyle {
  bg: string;
  text: string;
}

/*-----------------overview 生成状态文本和颜色-------------------*/

export const getOverviewStatusText = (status: OverviewStatus): string => {
  const statusMap: Record<OverviewStatus, string> = {
    [OverviewStatus.NoResponse]: 'No Response',
    [OverviewStatus.PartialSupported]: 'Partial Supported',
    [OverviewStatus.RejectProvide]: 'Reject Provide',
    [OverviewStatus.AllLost]: 'All Lost',
    [OverviewStatus.Freezed]: 'Freezed',
    [OverviewStatus.ProvidedNextAddress]: 'Provided Next Address',
    [OverviewStatus.FullyProvided]: 'Fully Provided',
  };
  return statusMap[status];
};

export const getOverviewStatusColor = (status: OverviewStatus): StatusStyle => {
  const colorMap: Record<OverviewStatus, StatusStyle> = {
    [OverviewStatus.RejectProvide]: {
      bg: '#EF454A29',
      text: '#EF454A',
    },
    [OverviewStatus.AllLost]: {
      bg: '#EF454A29',
      text: '#EF454A',
    },
    [OverviewStatus.NoResponse]: {
      bg: '#EF454A29',
      text: '#EF454A',
    },
    [OverviewStatus.PartialSupported]: {
      bg: '#F7A60029',
      text: '#F7A600',
    },
    [OverviewStatus.Freezed]: {
      bg: '#20B26C29',
      text: '#20B26C',
    },
    [OverviewStatus.ProvidedNextAddress]: {
      bg: '#20B26C29',
      text: '#20B26C',
    },
    [OverviewStatus.FullyProvided]: {
      bg: '#20B26C29',
      text: '#20B26C',
    },
  };
  return (
    colorMap[status] || {
      bg: '#EF454A29',
      text: '#EF454A',
    }
  );
};

/*-----------------report 生成状态文本和颜色-------------------*/

export const getReportStatusText = (status: ReportStatus): string => {
  const statusMap: Record<ReportStatus, string> = {
    [ReportStatus.No_Response]: 'noResponse',
    [ReportStatus.Reject_Support]: 'rejectSupport',
    [ReportStatus.Loss]: 'allLost',
    [ReportStatus.Blocked]: 'frozen',
    [ReportStatus.Partial_Blocked]: 'partiallyAddressed',
    [ReportStatus.PARTIALLY_ADDRESSED]: 'partiallyAddressed',
    [ReportStatus.PROVIDED_NEXT_ADDRESS]: 'providedNextDest',
  };
  return statusMap[status];
};

export interface ReportStatusStyle {
  text: string;
  backgroundColor: string;
  textColor: string;
}

export const getReportStatusColor = (
  status: ReportStatus
): { bg: string; text: string } => {
  const colorMap: Record<ReportStatus, { bg: string; text: string }> = {
    [ReportStatus.Blocked]: {
      bg: '#20B26C29',
      text: '#20B26C',
    },
    [ReportStatus.PROVIDED_NEXT_ADDRESS]: {
      bg: '#20B26C29',
      text: '#20B26C',
    },

    [ReportStatus.PARTIALLY_ADDRESSED]: {
      bg: '#F7A60029',
      text: '#F7A600',
    },
    [ReportStatus.Partial_Blocked]: {
      bg: '#F7A60029',
      text: '#F7A600',
    },

    [ReportStatus.Reject_Support]: {
      bg: '#EF454A29',
      text: '#EF454A',
    },
    [ReportStatus.No_Response]: {
      bg: '#EF454A29',
      text: '#EF454A',
    },
    [ReportStatus.Loss]: {
      bg: '#EF454A29',
      text: '#EF454A',
    },
  };
  return (
    colorMap[status] || {
      bg: '#EF454A29',
      text: '#EF454A',
    }
  );
};

export const getValue = (value?: string | number) => {
  if (!value) return '--';
  return value;
};
